import { useState, useEffect } from 'react';

interface UserPermissions {
  Excluded_Provider_Form?: boolean;
  APM_Form?: boolean;
  MCO_Form?: boolean;
}

export const usePermissions = () => {
  const [permissions, setPermissions] = useState<UserPermissions>({});

  useEffect(() => {
    const token = sessionStorage.getItem('internal_token');
    if (token) {
      try {
        const parsedToken = JSON.parse(token);
        setPermissions(parsedToken);
      } catch (error) {
        console.error("Error parsing internal_token:", error);
      }
    }
  }, []);

  return permissions;
};